module.exports = __webpack_public_path__ + "img/news_bg.135432e0.png";